import type { BalancePostingWrapperCollection } from '@festina/life-general-types/life'
import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { Card, CardBody, CardHeader } from '@festina-life/ui/structure'

import { BalancePostingsTable } from './BalancePostingsTable'

type Props = {
  balancePostings: Optional<BalancePostingWrapperCollection>
  onWorkPadFilterSelected?: (workPadId: Optional<string>) => void
  shouldHideAccount?: boolean
}

export const BalancePostingsCardTable = (props: Props) => {
  const translate = useTranslate()

  return (
    <Card>
      <CardHeader title={translate('collectivePots.balancePostings')} />
      <CardBody>
        <BalancePostingsTable {...props} />
      </CardBody>
    </Card>
  )
}
